module.exports = __webpack_public_path__ + "img/rightBottom4.3fb2e83.svg";